import { render } from "./LearningBaseAddArticle.vue?vue&type=template&id=4c2ffa2b&scoped=true"
import script from "./LearningBaseAddArticle.vue?vue&type=script&lang=js"
export * from "./LearningBaseAddArticle.vue?vue&type=script&lang=js"

import "./LearningBaseAddArticle.vue?vue&type=style&index=0&id=4c2ffa2b&scoped=true&lang=css"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c2ffa2b"]])

export default __exports__